import axios from 'axios';
import * as colors from '../../constants/colors';
import { snakeCaseToHumanReadable } from '@/utils/string';

const COLORS = {
  name: colors.NEUTRAL_SIGNAL_BOUNDING_BOX_COLOR_HEX,
  address: colors.NEUTRAL_SIGNAL_BOUNDING_BOX_COLOR_HEX,
  bank_account_name: colors.NEUTRAL_SIGNAL_BOUNDING_BOX_COLOR_HEX,
  bank_account_number: colors.NEUTRAL_SIGNAL_BOUNDING_BOX_COLOR_HEX,
  bank_account_beginning_balance: colors.NEUTRAL_SIGNAL_BOUNDING_BOX_COLOR_HEX,
  bank_account_ending_balance: colors.NEUTRAL_SIGNAL_BOUNDING_BOX_COLOR_HEX,
  transaction_description: colors.NEUTRAL_SIGNAL_BOUNDING_BOX_COLOR_HEX,
  transaction_date: colors.NEUTRAL_SIGNAL_BOUNDING_BOX_COLOR_HEX,
  transaction_amount: colors.NEUTRAL_SIGNAL_BOUNDING_BOX_COLOR_HEX,
  document_date: colors.NEUTRAL_SIGNAL_BOUNDING_BOX_COLOR_HEX,
  payslip_period: colors.NEUTRAL_SIGNAL_BOUNDING_BOX_COLOR_HEX,
  payslip_amount: colors.NEUTRAL_SIGNAL_BOUNDING_BOX_COLOR_HEX,
};

export default {
  state: {
    isLoading: false,
    documents: {},
  },
  actions: {
    getParsedDetailsHighlighterBoundingBoxes(
      context,
      { customerId, documentId, boundingBoxIds },
    ) {
      let url = `/api/v2/customers/${customerId}/documents/${documentId}/parsed-detail-highlighter`;

      if (boundingBoxIds) {
        url += `?bounding_box_ids=${boundingBoxIds}`;
      }

      return axios.get(url).then((response) => {
        context.commit('setParsedDetailsHighlighterDocument', {
          documentId,
          pages: response.data.results,
        });

        return response;
      });
    },
  },
  mutations: {
    setParsedDetailsHighlighterLoading(state, loading) {
      state.isLoading = loading;
    },
    setParsedDetailsHighlighterDocument(state, { documentId, pages }) {
      state.documents[documentId] = pages.map((page) => {
        return page.map((boundingBox) => {
          const label = snakeCaseToHumanReadable(boundingBox.parsed_type ?? '');
          return {
            color: COLORS[boundingBox.parsed_type],
            label,
            instance: {
              boundingBox,
              bounding_boxes: [boundingBox],
            },
          };
        });
      });
    },
  },
};
